<button
  type="button"
  mat-menu-item
  matTooltip="Copy Case"
  matTooltipPosition="above"
  [matTooltipShowDelay]="1000"
  (click)="copyCase()"
>
  <mat-icon>difference</mat-icon>
  <span>Copy Case</span>
</button>
